import { useEffect } from 'react';
import { Box, Grid, Typography, Container, Paper } from "@mui/material";
import imgUrl from "../../assets/images/imgUrl";

const registerYourself = [
  {
    text: (
      <>
        Join world’s <br />
        largest <br></br>
        Proposed I Am <br></br>
        Peacekeeper <br></br>
        Movement
      </>
    ),

    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Learn & live <br></br>7 Human <br></br>
        Values
      </>
    ),

    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Earn 21% I Am <br></br>
        Peacekeeper <br></br>
        Incentive
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Experience <br></br>
        inner Peace
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Be part <br></br>
        of World <br></br>
        Peace
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Sell I Am <br></br>
        Peacekeeper <br></br>
        Gifts & earn <br></br>
        21%
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
        Feel <br></br>
        positive, <br></br>
        conquer <br></br>
        fears
      </>
    ),
    colorClass: "gradient-blue",
  },
];

const highlights = [
  {
    title: "Declaration",
    description: <>
      Official recognition as an I Am Peacekeeper City : a Model City of Justice,
Love & Peace.
    </>,
    colorClass: "gradient-blue",
    image: []
  },
  {
    title: "Vision ",
    description: <>
      Transform the city into a beacon of Global Peace, inspired by the 28 Gems of
World Peace.
    </>,
    colorClass: "gradient-yellow",
    image: []
  },
  {
    title: "Movement  ",
    description: "Part of the I Am Peacekeeper Movement, active across continents, striving towards 1 Million I Am Peacekeeper by Dec 2026. ",
    colorClass: "gradient-blue",
    image: []
  },
  {
    title: "Global Reach  ",
    description: <>
      Recognition and partnerships across international platforms, drawing
Global visibility and impact.
    </>,
    colorClass: "gradient-yellow",
    image: []
  },
];

const whyItMatters = [
  <>
Pioneer status as one of the world’s first I Am Peacekeeper Cities . 
  </>,
  <>
  Commitment to cultivating the 7 Human Values Truth, Gratitude, Forgiveness, Love, Humility,
Giving, Patience.
  </>,

  <>
   I Am Peacekeeper Schools & Campuses displaying and practising the 7 Peace Values. 

  </>,
  <>
 Partnerships between local government, civil society and Global peace leaders.
  </>,
  <>
     Integration of values training and youth engagement across institutions. 
  </>,
  <>
   Global recognition, partnerships, tourism and media attention. 
  </>,
  <>
   Promotion of mental health, emotional wellness and community cohesion.
  </>
];

const howITWorks = [
  <>
    <b>I Am Peacekeeper Schools & Campuses </b> <br></br> Value education for students, teachers and
families. 
  </>,
  <>
   <b> I Am Peacekeeper Organisations </b> <br></br> Collaboration with NGOs and community
associations. 
  </>,

  <>
   <b> I Am Peacekeeper Corporates  </b>  Encouraging ethical and impact-driven business
practices. 

  </>,
  <>
   <b>I Am Peacekeeper Cafee  </b> <br></br>  A symbolic and physical space for dialogue, art and unity.
  </>,
  <>
     <b>I Am Peacekeeper Events  </b> <br></br> Hosting launches, summits, conclaves and cultural
gatherings. 
  </>,
  <>
    <b>Tourism  </b> <br></br> Attracting visitors to experience peace-driven culture and heritage. 
  </>,
  <>
     <b>Peace-based Investment  </b> <br></br> Positioning the city as a hub for ethical and values-led
enterprise.
  </>,
  <>
     <b>Community Health & Wellness  </b> <br></br> Initiatives to improve mental and emotional resilience. 

  </>,
  <>
    <b>Youth Empowerment  </b> <br></br> Engaging young people as leaders of tomorrow’s peace agenda. 
  </>,
  <>
    <b>Civic Engagement  </b> <br></br> Strengthening cooperation between citizens, local government and
leaders.
  </>,
  <>
    <b>Peace Media & Arts  </b> <br></br> Platforms to showcase creativity aligned with Justice, Love &
Peace.
  </>,
  <>
    <b>Global Partnerships  </b> <br></br> Building links with ambassadors, Nobel Laureates and international
networks.
  </>
];

const circleCourses = [
  {
    text: (
      <>
        Let cities lead the world in peace and unity.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
        Showcase values that transform communities into Global symbols of hope. 
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      From local to Global, a city becomes a visionary model for Justice, Love & Peace.
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Join the Movement today; become an I Am Peacekeeper City Partner.
      </>
    ),
    colorClass: "gradient-yellow",
  }
];

const globalBenefits = [
  {
    text: (
      <>
        Featured as an official I Am Peacekeeper City on Global platforms. 
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Official certification awarded by the I Am Peacekeeper International Governing Council. 
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Opportunities to host international Summits and Conclaves. 
      </>
    ),
    colorClass: "gradient-blue",
  },
  {
    text: (
      <>
       Attraction of CSR investment, NGOs and aligned partnerships.
      </>
    ),
    colorClass: "gradient-yellow",
  },
   {
    text: (
      <>
      Visits from Global ambassadors, Nobel Peace Laureates and thought leaders.
      </>
    ),
    colorClass: "gradient-blue",
  },
   {
    text: (
      <>
        International media visibility through campaigns, documentaries and interviews. 
      </>
    ),
    colorClass: "gradient-yellow",
  },
  {
    text: (
      <>
       Positioning the city as a Global hub for peace, unity and sustainable development. 
      </>
    ),
    colorClass: "gradient-blue",
  },
];

const InfoCard = ({ text }) => (
  <Paper elevation={3} className="infoCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const ProgramCard = ({ text }) => (
  <Paper elevation={3} className="CircleCard">
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const BlockCard = ({  title,
  description,
  colorClass = "gradient-green",
  image, }) => (
  <Paper elevation={3} className="infoCard">
     {/* <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    /> */}
    <Typography variant="" fontWeight="bold" sx={{fontFamily:"var(--default-font)"}}>
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem"}}>
      {description}
    </Typography>
  </Paper>
);

const ConclusionCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`programCard gradientTrioCards gradientTrioBigCards ${colorClass}`}
    sx={{
      width: 140,
      height: 140,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const CircleBox = ({
  title,
  description,
  colorClass = "gradient-green",
  image,
}) => (
  <Box
    className={`circleBox ${colorClass}`}
    sx={{
      width: 180,
      height: 180,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 4,
      m: "auto",
    }}
  >
    <img
      src={image || imgUrl.defaultIcon}
      alt={`${title} icon`}
      style={{ width: 40, height: 40, marginBottom: 1 }}
    />
    <Typography variant="subtitle1" fontWeight="bold">
      {title}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: "0.8rem" }}>
      {description}
    </Typography>
  </Box>
);


const RegisterYourselfCard = ({ text, colorClass }) => (
  <Paper
    elevation={3}
    className={`gradientCard ${colorClass}`}
    sx={{
      width: 130,
      height: 130,
      borderRadius: "50%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: 2,
      m: "auto",
    }}
  >
    <Typography variant="body2">{text}</Typography>
  </Paper>
);

const Cities = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Registration Hero Background Section */}
      <Box
        className="programCoinSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition:"center",
          color: "white",
          px: 2,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Registration Main Section */}
      <Box className="" mt={5}>
        <Grid container direction="column" alignItems="center" spacing={2}>
          <Grid
            item
            size={12}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
          >
            <img src={imgUrl.peaceIcon} className="w-100 peaceImg"></img>
            <Typography variant="h5" className="founder-title mainHeading green-title">
            <h1>  I Am Peacekeeper 
              Cities</h1>
            </Typography>
          </Grid>
        </Grid>
      </Box>

                 {/* Top Section UI */}
       <Box className="schoolProgramMainSection topBlockBox" mt={5}>
               {/* <Typography
                          variant="h5"
                          align="center"
                          fontWeight="bold"
                          gutterBottom
                          className="subHeading"
                          pt={5}
                        >
                         TOP
                        </Typography> */}
                 <Container>
                <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                  {highlights.map((item, index) => (
                   <Grid size={{xs: 12, md: 3, sm: 6  }} key={index}>
                                                    <BlockCard title={item.title}
                                     description={item.description}
                                     colorClass={item.colorClass}
                                    //  image={item.image} 
                                                     />
                                                  </Grid>
                  ))}
                </Grid>
              </Container>
              </Box>

              {/* why it matters */}
                <Box mt={5} className="programCardMain corporateMainSection mt-50px">
                                <Typography
                                  variant="h2"
                                  align="center"
                                  fontWeight="bold"
                                  gutterBottom
                                  className="subHeading mb-0px"
                                >
                                  Why a City Becomes an I Am Peacekeeper City 
                                </Typography>
                                {/* <p align="center">
                                  Your organization’s partnership directly supports your Corporate
                                  Social <br></br> Responsibility (CSR) goals
                                </p> */}
                      
                                <Container className="paddingSubContainer programCardContainer mt-30px">
                                  <Grid
                                    container
                                    spacing={2}
                                    mt={1}
                                    justifyContent="center"
                                    alignItems="center"
                                    display="flex"
                                  >
                                    {whyItMatters.map((text, index) => (
                                      <Grid
                                        size={{ xs: 12, md: 3, sm: 4 }}
                                        key={index}
                                        justifyContent="center"
                                        alignItems="center"
                                        display="flex"
                                        
                                      >
                                        <ProgramCard text={text} />
                                      </Grid>
                                    ))}
                                  </Grid>
                                </Container>
                              </Box>
                {/* Core Initiatives of an I Am Peacekeeper City  */}
                               <Box className="schoolProgramMainSection">
                                  <Typography
                                         variant="h2"
                                         align="center"
                                         fontWeight="bold"
                                         gutterBottom
                                         mt={5}
                                         className="subHeading mt-50px"
                                       >
                                        Core Initiatives of an I Am Peacekeeper City 
                                       </Typography>
                                       <Container className="paddingSubContainer">
                                         <Grid container spacing={1} mt={5} mb={2} justifyContent="center">
                                           {howITWorks.map((text, index) => (
                                             <Grid size={{ xs: 12, md: 3, sm: 6 }} key={index}>
                                               <InfoCard text={text} 
                                                />
                                             </Grid>
                                           ))}
                                         </Grid>
                                       </Container>
                               </Box>  

                                {/* Global Benefits of an I Am Peacekeeper City */}
                                <Box
                                                        sx={{
                                                          textAlign: "center",
                                                          borderRadius: 3,
                                                          marginBottom:'50px'
                                                        }}
                                                        mt={5} pt={3}
                                                        className="TabPaddingContainer TabPaddingMainContainer">
                                                       {/* Title */}
                                                        <Typography
                                                          variant="h2"
                                                          fontWeight="bold"
                                                          gutterBottom
                                                          className="subHeading"
                                                        >
                                                          Global Benefits of an I Am Peacekeeper City 

                                                        </Typography>
                                                       <Container className="paddingContainer mt-50px" mb={5} pt={4}>
                                                          <Grid container spacing={2} justifyContent="center" mb={4}>
                                                            {globalBenefits.map(({ text, colorClass }, index) => (
                                                              <Grid size={{ xs: 12, sm: 3, md: 3 }} key={index}>
                                                                <ConclusionCard text={text} colorClass={colorClass} />
                                                              </Grid>
                                                            ))}
                                                          </Grid>
                                                        </Container>
                                </Box>  

                               {/* closing */}
                                <Box
                                                        sx={{
                                                          textAlign: "center",
                                                          borderRadius: 3,
                                                          marginBottom:'70px'
                                                        }}
                                                       
                                                        className="TabPaddingContainer TabPaddingMainContainer">
                                                       {/* Title */}
                                                        <Typography
                                                          variant="h2"
                                                          fontWeight="bold"
                                                          gutterBottom
                                                          className="subHeading"
                                                        >
                                                        Legacy of Justice, Love & Peace 
                                                        </Typography>
                                                       <Container className="paddingContainer mt-50px" mb={5}>
                                                          <Grid container spacing={5} justifyContent="center" mb={4}>
                                                            {circleCourses.map(({ text, colorClass }, index) => (
                                                              <Grid size={{ xs: 12, sm: 3, md: 2 }} key={index}>
                                                                <ConclusionCard text={text} colorClass={colorClass} />
                                                              </Grid>
                                                            ))}
                                                          </Grid>
                                                        </Container>
                                </Box>     


    </>
  );
};

export default Cities;
